module.exports = __webpack_public_path__ + "img/72.b64b77d6.svg";